// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunk-" + chunkId + "-" + {"895":"9abb180eed091ba38fe6","3827":"007693d3610198bbd5e4","5692":"d90429d53f2c436d42a3","7113":"df708ca8d93a7e5e2340"}[chunkId] + ".bundle.css";
};